module.exports = __webpack_public_path__ + "data-sharing.14d60f42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/chatbotmakers/data-sharing.png
// module id = 928
// module chunks = 0